// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};



//////////////////
// WEBPACK FOOTER
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/~/core-js/modules/_iobject.js
// module id = ../../../../core-js/modules/_iobject.js
// module chunks = 0